'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'citrus-slice';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e2f5';
var svgPathData = 'M496 208c0 159.1-128.9 288-288 288c-69.7 0-133.6-24.7-183.4-66L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232c0-58.3-21.5-111.6-57-152.3L430 24.6c41.2 49.8 66 113.7 66 183.4zM184 429.6c-41.3-6.1-78.8-24-109-50l99.1-99.1c3.2 1.5 6.5 2.8 9.9 3.8l0 145.3zm16 1.8l0-143.8c2.6 .3 5.3 .4 8 .4c19.2 0 36.8-6.8 50.6-18.1L363 374.3C324.4 410.1 272.8 432 216 432c-5.4 0-10.7-.2-16-.6zm69.9-172.8C281.2 244.8 288 227.2 288 208c0-2.7-.1-5.4-.4-8l143.8 0c.4 5.3 .6 10.6 .6 16c0 56.8-21.9 108.4-57.7 147L269.9 258.6zM284.3 184c-1.1-3.4-2.4-6.7-3.8-9.9L379.6 75c26.1 30.2 43.9 67.7 50 109l-145.3 0zm-16.1 2.4c2.4 6.8 3.7 14 3.7 21.6c0 35.3-28.7 64-64 64c-7.6 0-14.9-1.3-21.6-3.7l81.9-81.9zM1.2 430.8c3.9 3.6 7.9 7.2 12 10.6C66 485.5 133.9 512 208 512c167.9 0 304-136.1 304-304c0-74.1-26.5-142-70.6-194.8c-3.4-4.1-7-8.1-10.6-12L419.5 12.5l-407 407L1.2 430.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCitrusSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;